import { PointerEvent } from 'react';

/** Feeds a card's cursor light the pointer position (`card-cursor-light` in `_card-edge.scss`,
 *  and the workspace capability cards), as CSS variables so the card doesn't re-render on
 *  every move. */
export const trackCardLight = (e: PointerEvent<HTMLElement>) => {
  const rect = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty('--light-x', `${e.clientX - rect.left}px`);
  e.currentTarget.style.setProperty('--light-y', `${e.clientY - rect.top}px`);
};
